<h3 class="sectionTitle" i18n="@@activateddevices_activations_count">Conteggio attivazioni:</h3>

<div id="activatedDevicesSummary" div fxLayout="row" fxLayoutAlign="start center">
  <div fxFlex="30">
    <p  i18n="@@activateddevices_count">Totale dispositivi attivati:
      {{activeDevC}} </p>
  </div>
  <div fxFlex="30">
    <p  i18n="@@activateddevices_not_RnD">Esclusi R&D 1Control :
      {{piloActiveDevC}} </p>
  </div>
</div>

<div class="table-container">

  <table mat-table matSort #devicesactivatedtotalstable class="simple-table">
    <!-- 'month', 'year', 'activations', 'totalActivations' -->
    <ng-container matColumnDef="month">
      <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@activateddevices_month" style="width: 10%;">Mese
      </th>
      <td mat-cell *matCellDef="let element"> {{ element.month }} </td>
    </ng-container>

    <ng-container matColumnDef="year">
      <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@activateddevices_year" style="width: 10%;">Anno</th>
      <td mat-cell *matCellDef="let element"> {{ element.year }} </td>
    </ng-container>

    <ng-container matColumnDef="activatedDevices">
      <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@activateddevices_activatedDevices"
        style="width: 15%;">Attivazioni mensili</th>
      <td mat-cell *matCellDef="let element"> {{ element.activatedDevices }} </td>
    </ng-container>

    <ng-container matColumnDef="subTotalActivatedDevices">
      <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@activateddevices_subTotalActivatedDevices"
        style="width: 15%;">Sub-totale attivazioni</th>
      <td mat-cell *matCellDef="let element"> {{ element.subTotalActivatedDevices }} </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumnsTotals"></tr>

    <tr mat-row *matRowDef="let row; columns: displayedColumnsTotals;">
    </tr>

  </table>

</div>

<h3 class="sectionTitle" i18n="@@activateddevices_activated_devices_list">Dispositivi attivati:</h3>

<div class="table-container">

  <table mat-table matSort #devicesactivatedlisttable class="simple-table">

    <ng-container matColumnDef="serial">
      <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@activateddevices_serial" style="width: 15%;">Seriale
      </th>
      <td mat-cell *matCellDef="let element"> {{ element.serial }} </td>
    </ng-container>

    <ng-container matColumnDef="activationDateFriendly">
      <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@activateddevices_activationDateFriendly" style="width: 15%;">
        Data attivazione</th>
      <td mat-cell *matCellDef="let element"> {{ element.activationDateFriendly }} </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumnsList"></tr>

    <tr mat-row *matRowDef="let row; columns: displayedColumnsList;" (click)="onRowClicked(row)"
      [class.mat-cell-selected]="selectedRow == row.id" class="clickable">
    </tr>

  </table>

</div>

<app-loading-screen #devicesactivatedlistloader></app-loading-screen>